// extracted by mini-css-extract-plugin
module.exports = {"bg-text":"drop_bg-text__2FuQ2","heading":"drop_heading__28bS9"};